import { storeWrapper } from '../storeWrapper'
import { ospreyAPI } from '@repo/api/ospreyAPI'
import { ospreyKpiChartSchema } from '@repo/validation/schema_ospreyAPI'
import { useAuthenticationStore } from '@repo/store/useAuthenticationStore'
import themeConfig from '@repo/theme/themeConfig'
import { debounce } from '@repo/utils/debounce'
const { palette } = themeConfig

const initialState = {
  kpiOptions: null,
  selectedKpiId: null,
  feeEarnerIds: null,
  userSpecifiedTargets: {}
}

const formatLabel = (label) => {
  const lowerLabel = label.toLowerCase().replace('wip', 'WIP')
  return lowerLabel.charAt(0).toUpperCase() + lowerLabel.slice(1)
}

const getKpiEndpoint = (kpiId) => {
  switch (kpiId) {
    case 3:
      return 'Kpi/GetTimeSpentWip'
    case 4:
      return 'Kpi/GetCompletedMatters'
    case 5:
      return 'Kpi/GetFeesBilled'
    case 6:
      return 'Kpi/GetFeesReceived'
    case 7:
      return 'Kpi/GetFilesOpened'
    case 8:
      return 'Kpi/GetOutstandingFees'
    case 9:
      return 'Kpi/GetTimeSpentBilled'
  }
}

export const useKpiStore = storeWrapper('useKpiStore', (set, get) => ({
  ...initialState,
  fetchKpiOptions: async () => {
    debounce({
      id: 'fetchKpiOptions',
      delay: 300,
      callback: async () => {
        let fetchedKpiOptions = await ospreyAPI({
          service: 'kpis',
          endpoint: 'Kpi/GetAllByCurrentUser'
        })

        fetchedKpiOptions = fetchedKpiOptions?.map((opt) => ({
          ...opt,
          description: formatLabel(opt.description),
          label: formatLabel(opt.description),
          value: opt.kpiId,
          endpoint: getKpiEndpoint(opt.kpiId),
          disabled: false,
          units:
            opt.description.toLowerCase().includes('fees') || opt.description.toLowerCase().includes('time') ? '£' : ''
        }))

        set({ kpiOptions: fetchedKpiOptions })
      }
    })
  },
  setSelectedKpiId: (selectedKpiId) => {
    set({ selectedKpiId })
  },
  setFeeEarnerIds: (feeEarnerIds) => {
    set({ feeEarnerIds })
  },
  setKpiTarget: ({ kpiId, target }) => {
    const { userSpecifiedTargets } = get()
    if (!userSpecifiedTargets) return

    userSpecifiedTargets[kpiId] = Number(target)

    set({ userSpecifiedTargets: { ...userSpecifiedTargets } })
  },
  fetchKpiData: async ({ kpiId, feeEarnerIds }) => {
    const kpi = get().kpiOptions.find((opt) => opt.kpiId === kpiId)
    if (!kpi || !feeEarnerIds?.length) return []

    const { endpoint } = kpi

    if (!feeEarnerIds) {
      const defaultFeeEarnerId = useAuthenticationStore.getState().feeEarnerId
      if (defaultFeeEarnerId) feeEarnerIds = [defaultFeeEarnerId]
      else return
    }

    if (feeEarnerIds && Array.isArray(feeEarnerIds) && feeEarnerIds.length) {
      feeEarnerIds = feeEarnerIds.join(',')
    }

    const result = await ospreyAPI({
      service: 'kpis',
      endpoint,
      data: { feeEarnerIds },
      schema: ospreyKpiChartSchema
    })

    result[0].color = palette.support.sand
    result[1].color = palette.support.osprey

    return result
  },
  reset: () => {
    const { userSpecifiedTargets, feeEarnerIds } = get()
    set({ ...initialState, userSpecifiedTargets, feeEarnerIds })
  }
}))
